import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  connect() {
    this.noKeyboardMobile();

    const withTime = this.data.get("with-time") == "true";
    const withWeekends = this.data.get("with-weekends") == "true";
    const withMinDate = this.data.get("with-min-date") == "true";
    const withMaxDate = this.data.get("with-max-date") == "true";
    const withFutureDate = this.data.get("with-future-date") == "true";

    this.initFlatpickr(withTime, withWeekends, withMinDate, withMaxDate, withFutureDate, navigator.userAgent);
  }

  noKeyboardMobile() {
    this.element.querySelectorAll(".datepicker").forEach((element) => {
      element.setAttribute("autocomplete", "off");
      element.addEventListener("focus", function () {
        this.blur();
      });
    });
  }

  setRequired() {
    const firstDatepickerElement = this.element.querySelector(".datepicker");
    firstDatepickerElement.setAttribute("required", "true");
  }

  parseWallClockDate(dateStr) {
    // DD-MM-YYYY (Rails date display format / flatpickr output)
    const dmyMatch = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})(?:[T ](\d{2}):(\d{2}))?$/);
    if (dmyMatch) {
      const [, day, month, year, hours = "0", minutes = "0"] = dmyMatch;
      return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hours, 10), parseInt(minutes, 10));
    }
    // YYYY-MM-DD (ISO date / Rails Date#to_s / DateTime#to_s)
    const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
    if (isoMatch) {
      const [, year, month, day, hours = "0", minutes = "0"] = isoMatch;
      return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hours, 10), parseInt(minutes, 10));
    }
    return null;
  }

  initFlatpickr(withTime, withWeekends, withMinDate, withMaxDate, withFutureDate, useragent) {
    const currentDate = new Date();
    const defaultDate = this.element.querySelector(".datepicker").value;
    var setDateTime = null;

    if (defaultDate) {
      setDateTime = this.parseWallClockDate(defaultDate);
    }

    if (withMinDate) {
      currentDate.setDate(currentDate.getDate() + 7); }
    else if (withFutureDate) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(useragent)) {
      flatpickr(this.element.querySelector(".datepicker"), {
        enableTime: withTime,
        defaultDate: setDateTime,
      });
        } else {
      flatpickr(this.element.querySelector(".datepicker"), {
        dateFormat: withTime ? "d-m-Y H:i" : "d-m-Y",
        altInput: true,
        altFormat: withTime ? "d/m/Y H:i" : "d/m/Y",
        allowInput: true,
        minDate: withMinDate || withFutureDate ? currentDate : null,
        maxDate: withMaxDate ? currentDate : null,
        enableTime: withTime,
        defaultDate: setDateTime,
        enable: [
          function (date) {
        return withWeekends || date.getDay() % 6 != 0; // disable weekends
          },
        ],
      });
    }
  }
}
